export type FloatingButtonStyleConfig = {
    color: string;
    iconSize: number;
};

const DEFAULT_COLOR = '#AAF775';
const DEFAULT_ICON_SIZE = 24;
const MIN_ICON_SIZE = 16;
const MAX_ICON_SIZE = 40;

function normalizeColor(color: string | undefined): string {
    const value = (color ?? DEFAULT_COLOR).trim();

    return /^#[0-9A-Fa-f]{6}$/.test(value) ? value : DEFAULT_COLOR;
}

function normalizeIconSize(size: number | string | undefined): number {
    const value =
        typeof size === 'number'
            ? size
            : Number.parseInt(String(size ?? ''), 10);

    if (!Number.isFinite(value)) {
        return DEFAULT_ICON_SIZE;
    }

    return Math.min(MAX_ICON_SIZE, Math.max(MIN_ICON_SIZE, Math.round(value)));
}

export function contrastTextColor(backgroundColor: string): string {
    const hex = backgroundColor.replace('#', '');

    if (hex.length !== 6) {
        return '#001715';
    }

    const r = Number.parseInt(hex.slice(0, 2), 16);
    const g = Number.parseInt(hex.slice(2, 4), 16);
    const b = Number.parseInt(hex.slice(4, 6), 16);
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

    return luminance > 0.72 ? '#001715' : '#ffffff';
}

export function resolveFloatingButtonStyle(
    partial?: Partial<FloatingButtonStyleConfig> | null,
): FloatingButtonStyleConfig {
    return {
        color: normalizeColor(partial?.color),
        iconSize: normalizeIconSize(partial?.iconSize),
    };
}

export function defaultFloatingColorFromDarkFlag(darkLauncher: boolean): string {
    return darkLauncher ? '#001715' : '#AAF775';
}
